var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { createContext, useCallback, useState } from 'react';
import { useAsyncEffect, useAsyncState, wrap } from '@hilma/tools';
import { useLanguage } from '../hooks';
export var IsGoogleMapsLoadingContext = createContext(null);
export var RunGoogleMapsEffectContext = createContext(null);
var GoogleMapsProvider = function (_a) {
    var children = _a.children;
    var _b = useAsyncState(true), isLoading = _b[0], setIsLoading = _b[1];
    var _c = useState(false), runEffect = _c[0], setRunEffect = _c[1];
    var language = useLanguage();
    var runMapsEffect = useCallback(function () {
        setRunEffect(true);
    }, []);
    useAsyncEffect(function () { return __awaiter(void 0, void 0, void 0, function () {
        var script;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!runEffect ||
                        typeof window === 'undefined' ||
                        !document.querySelector('head') ||
                        document.querySelector('#google-maps'))
                        return [2 /*return*/];
                    return [4 /*yield*/, setIsLoading(true)];
                case 1:
                    _a.sent();
                    script = document.createElement('script');
                    script.setAttribute('async', '');
                    script.setAttribute('id', 'google-maps');
                    script.src = "https://maps.googleapis.com/maps/api/js?key=" + process.env.REACT_APP_MAPS_KEY + "&language=" + (language || 'he') + "&region=IL&libraries=places";
                    script.type = 'text/javascript';
                    document.querySelector('head').appendChild(script);
                    script.onload = function () {
                        setIsLoading(false);
                    };
                    return [2 /*return*/, function () {
                            window.google = undefined;
                            var scripts = document.head.getElementsByTagName("script");
                            var script = scripts.namedItem('google-maps');
                            script === null || script === void 0 ? void 0 : script.remove();
                        }];
            }
        });
    }); }, [language, runEffect]);
    return wrap([RunGoogleMapsEffectContext.Provider, { value: runMapsEffect }], [IsGoogleMapsLoadingContext.Provider, { value: isLoading }])(children);
};
export default GoogleMapsProvider;
//# sourceMappingURL=GoogleMapsProvider.js.map